export const SET_MASTER_DOCUMENTS = "SET_MASTER_DOCUMENTS";
export const RESET_MASTER_DOCUMENTS = "RESET_MASTER_DOCUMENTS";
export const ADD_MASTER_DOCUMENTS = "ADD_MASTER_DOCUMENTS";
export const RESET_MASTER_DOCUMENTS_STORE = "RESET_MASTER_DOCUMENTS_STORE";
export const SET_FILTERS = "SET_FILTERS";
export const UPDATE_PAGE = "UPDATE_PAGE";
